import { render, staticRenderFns } from "./collectExcel.vue?vue&type=template&id=5dd815df&scoped=true&"
import script from "./collectExcel.vue?vue&type=script&lang=js&"
export * from "./collectExcel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd815df",
  null
  
)

export default component.exports